export const AppPrintAndExportTypes = {
  PRINT: 1,
  PDF: 2,
  excel: 3,
};

export const SourceEnum = {
  clients: "clients",
};

export const DestinationEnum = {
  employees: "employees",
  vendors: "vendors",
};
